// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICensusIncomingRecordDto
 */
export interface ICensusIncomingRecordDto {
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    partner_id: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    employer_id: string;
    /**
     * Required if idSource is EID
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    employer_employee_id?: string;
    /**
     * Required if idSource is SSN
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    ssn?: string;
    /**
     * Required if idSource is PID
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    id_source: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    suffix?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    birth_on?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    gender?: ICensusIncomingRecordDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    zipcode: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    country_code?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    mailing_line1: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    mailing_line2?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    mailing_city?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    mailing_state?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    mailing_zipcode?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    mailing_country_code?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    email_type?: ICensusIncomingRecordDtoEmailTypeEnum;
    /**
     * Valid US phone number
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    phone1_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    phone1_type?: ICensusIncomingRecordDtoPhone1TypeEnum;
    /**
     * Valid US phone number
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    phone2_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    phone2_type?: ICensusIncomingRecordDtoPhone2TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    employment_status: ICensusIncomingRecordDtoEmploymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    employment_status_effective_on: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    subsidiary_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    subgroup_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    bank_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    bank_routing_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    bank_account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    bank_account_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    payment_preference?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    payroll_group_code?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    valid_from?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    custom_field1?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    custom_field2?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    custom_field3?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    custom_field4?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    custom_field5?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusIncomingRecordDto
     */
    middle_name?: string;
}

/**
* @export
* @enum {string}
*/
export enum ICensusIncomingRecordDtoGenderEnum {
    M = 'M',
    F = 'F',
    O = 'O'
}
/**
* @export
* @enum {string}
*/
export enum ICensusIncomingRecordDtoEmailTypeEnum {
    H = 'H',
    W = 'W',
    O = 'O'
}
/**
* @export
* @enum {string}
*/
export enum ICensusIncomingRecordDtoPhone1TypeEnum {
    M = 'M',
    H = 'H',
    U = 'U',
    W = 'W'
}
/**
* @export
* @enum {string}
*/
export enum ICensusIncomingRecordDtoPhone2TypeEnum {
    M = 'M',
    H = 'H',
    U = 'U',
    W = 'W'
}
/**
* @export
* @enum {string}
*/
export enum ICensusIncomingRecordDtoEmploymentStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R'
}


/**
 * Check if a given object implements the ICensusIncomingRecordDto interface.
 */
export function instanceOfICensusIncomingRecordDto(value: object): value is ICensusIncomingRecordDto {
    if (!('partner_id' in value) || value['partner_id'] === undefined) return false;
    if (!('employer_id' in value) || value['employer_id'] === undefined) return false;
    if (!('id_source' in value) || value['id_source'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipcode' in value) || value['zipcode'] === undefined) return false;
    if (!('mailing_line1' in value) || value['mailing_line1'] === undefined) return false;
    if (!('employment_status' in value) || value['employment_status'] === undefined) return false;
    if (!('employment_status_effective_on' in value) || value['employment_status_effective_on'] === undefined) return false;
    return true;
}

export function ICensusIncomingRecordDtoFromJSON(json: any): ICensusIncomingRecordDto {
    return ICensusIncomingRecordDtoFromJSONTyped(json, false);
}

export function ICensusIncomingRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICensusIncomingRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'partner_id': json['partner_id'],
        'employer_id': json['employer_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'id_source': json['id_source'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'birth_on': json['birth_on'] == null ? undefined : json['birth_on'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'city': json['city'],
        'state': json['state'],
        'zipcode': json['zipcode'],
        'country_code': json['country_code'] == null ? undefined : json['country_code'],
        'mailing_line1': json['mailing_line1'],
        'mailing_line2': json['mailing_line2'] == null ? undefined : json['mailing_line2'],
        'mailing_city': json['mailing_city'] == null ? undefined : json['mailing_city'],
        'mailing_state': json['mailing_state'] == null ? undefined : json['mailing_state'],
        'mailing_zipcode': json['mailing_zipcode'] == null ? undefined : json['mailing_zipcode'],
        'mailing_country_code': json['mailing_country_code'] == null ? undefined : json['mailing_country_code'],
        'email': json['email'] == null ? undefined : json['email'],
        'email_type': json['email_type'] == null ? undefined : json['email_type'],
        'phone1_number': json['phone1_number'] == null ? undefined : json['phone1_number'],
        'phone1_type': json['phone1_type'] == null ? undefined : json['phone1_type'],
        'phone2_number': json['phone2_number'] == null ? undefined : json['phone2_number'],
        'phone2_type': json['phone2_type'] == null ? undefined : json['phone2_type'],
        'employment_status': json['employment_status'],
        'employment_status_effective_on': json['employment_status_effective_on'],
        'subsidiary_id': json['subsidiary_id'] == null ? undefined : json['subsidiary_id'],
        'subgroup_id': json['subgroup_id'] == null ? undefined : json['subgroup_id'],
        'bank_name': json['bank_name'] == null ? undefined : json['bank_name'],
        'bank_routing_number': json['bank_routing_number'] == null ? undefined : json['bank_routing_number'],
        'bank_account_number': json['bank_account_number'] == null ? undefined : json['bank_account_number'],
        'bank_account_type': json['bank_account_type'] == null ? undefined : json['bank_account_type'],
        'payment_preference': json['payment_preference'] == null ? undefined : json['payment_preference'],
        'payroll_group_code': json['payroll_group_code'] == null ? undefined : json['payroll_group_code'],
        'valid_from': json['valid_from'] == null ? undefined : json['valid_from'],
        'custom_field1': json['custom_field1'] == null ? undefined : json['custom_field1'],
        'custom_field2': json['custom_field2'] == null ? undefined : json['custom_field2'],
        'custom_field3': json['custom_field3'] == null ? undefined : json['custom_field3'],
        'custom_field4': json['custom_field4'] == null ? undefined : json['custom_field4'],
        'custom_field5': json['custom_field5'] == null ? undefined : json['custom_field5'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
    };
}

export function ICensusIncomingRecordDtoToJSON(json: any): ICensusIncomingRecordDto {
    return ICensusIncomingRecordDtoToJSONTyped(json, false);
}

export function ICensusIncomingRecordDtoToJSONTyped(value?: ICensusIncomingRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partner_id': value['partner_id'],
        'employer_id': value['employer_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'partner_employee_id': value['partner_employee_id'],
        'id_source': value['id_source'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'birth_on': value['birth_on'],
        'gender': value['gender'],
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'state': value['state'],
        'zipcode': value['zipcode'],
        'country_code': value['country_code'],
        'mailing_line1': value['mailing_line1'],
        'mailing_line2': value['mailing_line2'],
        'mailing_city': value['mailing_city'],
        'mailing_state': value['mailing_state'],
        'mailing_zipcode': value['mailing_zipcode'],
        'mailing_country_code': value['mailing_country_code'],
        'email': value['email'],
        'email_type': value['email_type'],
        'phone1_number': value['phone1_number'],
        'phone1_type': value['phone1_type'],
        'phone2_number': value['phone2_number'],
        'phone2_type': value['phone2_type'],
        'employment_status': value['employment_status'],
        'employment_status_effective_on': value['employment_status_effective_on'],
        'subsidiary_id': value['subsidiary_id'],
        'subgroup_id': value['subgroup_id'],
        'bank_name': value['bank_name'],
        'bank_routing_number': value['bank_routing_number'],
        'bank_account_number': value['bank_account_number'],
        'bank_account_type': value['bank_account_type'],
        'payment_preference': value['payment_preference'],
        'payroll_group_code': value['payroll_group_code'],
        'valid_from': value['valid_from'],
        'custom_field1': value['custom_field1'],
        'custom_field2': value['custom_field2'],
        'custom_field3': value['custom_field3'],
        'custom_field4': value['custom_field4'],
        'custom_field5': value['custom_field5'],
        'middle_name': value['middle_name'],
    };
}

